// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"f9d09424","92":"7a9171d3","99":"63165617","215":"6c6141a7","337":"44cf4e11","443":"8a7c633c","453":"aff6c9da","479":"7bfef9a7","531":"f15c1420","952":"1ab539f2"}[chunkId] + ".chunk.js";
};